<template>
  <b-card
    no-body
    class="import-action-card h-100 shadow-sm"
    @click="$emit('click')"
  >
    <b-card-body class="import-action-card__body d-flex align-items-center p-3">
      <div
        :class="[
          'import-action-card__icon rounded-circle d-flex align-items-center justify-content-center mr-3',
          subtitle ? 'import-action-card__icon--primary' : 'import-action-card__icon--secondary'
        ]"
      >
        <i :class="['fa', iconClass]" />
      </div>
      <div class="import-action-card__content">
        <h6 class="mb-0">
          {{ label }}
        </h6>
        <small
          v-if="subtitle"
          class="text-muted"
        >
          {{ subtitle }}
        </small>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  name: 'ImportActionCard',
  props: {
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: 'fa-arrow-right',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
  computed: {
    iconClass() {
      const base = this.icon.startsWith('fa') ? this.icon : `fa ${this.icon}`;
      return this.subtitle ? `${base} text-primary` : `${base} text-secondary`;
    },
  },
};
</script>

<style scoped>
.import-action-card {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.import-action-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  border-color: #007bff;
}
.import-action-card__icon {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
}
.import-action-card__icon--primary {
  background-color: #e9ecef;
}
.import-action-card__icon--secondary {
  background-color: #f8f9fa;
}
</style>
